(function () {
    'use strict';

    angular.module('app')
        .controller('suscriptorEditConroller', Controller);

    /* @ngInject */
    function Controller(item, ModalService) {
        var vm = this;

        vm.dismiss = ModalService.dismiss;
        vm.item = item;

        vm.confirm = function () {
            vm.item.$save().then(function () {
                ModalService.close(vm.item);
            });
        };
    }
})();
